import { Injectable } from '@angular/core';
import {AngularFireDatabase} from "@angular/fire/database";
import {Observable} from "rxjs";
import {AgendaItem} from "./agendaItem";
import { of } from 'rxjs';
import {Field} from "./field";
import {forEach} from "@angular/router/src/utils/collection";
import {filter} from "rxjs/operators";
import {AuthService} from "../security/auth.service";
import {CommandService} from "./command.service";

@Injectable({
  providedIn: 'root'
})
export class AgendaService {
  static agendaPath = '/agenda/';

  private agendaItems$: Observable<AgendaItem[]> = null;
  private a: AgendaItem[] = [];


  // Structure: day, tenantId, courtId, { reservation }
  //
  // [ null, {
  //     "310001" : [ null, {
  //       "court" : 3,
  //       "endTime" : "22:55",
  //       "startTime" : "20:50",
  //       "type" : "normal"
  //     }, {
  //       "court" : 5,
  //       "endTime" : "23:25",
  //       "startTime" : "20:50",
  //       "type" : "normal"
  //     }, ...
  // ]
  constructor(private db:AngularFireDatabase, private authService: AuthService, private commandService: CommandService) {
  }

  findAgendaItemsForTenant(): Observable<AgendaItem[]> {
    this.db.object(AgendaService.agendaPath).valueChanges().subscribe(data => {
      //console.log('data:');
      //console.log(JSON.stringify(data));

      const currentTenantId = this.authService.getTenantIdForUser();
      this.a.splice(0, this.a.length);  // cleanup old content of array


      for ( let i = 0; i <= Object.keys(data).length; i++ ) {  // iterate over all days, skip day 0
        if ( data[i] ) {
          let day = data[i];
          let dayNumber = i;
          //console.log(`day: : ${JSON.stringify(json[i])}`);
          //console.log(`day of the week: ${dayNumber}`);

          const tenantIds = Object.keys( day );
          for ( const tenantId of tenantIds ) {
            if ( Number(tenantId) === currentTenantId) {
              if ( data[i][tenantId] ) {
                let itemContent = data[i][tenantId];
                // console.log(`content for tenant ${tenantId}: ${JSON.stringify(itemContent)}`);
                const reservationIds = Object.keys( itemContent );
                // console.log( `reservationIds: ${reservationIds}`);

                for ( const reservationId of reservationIds ) {
                  // console.log( `reservationId: ${reservationIds}` );
                  let reservation = itemContent[reservationId];
                  if ( reservation ) {
                    // console.log( JSON.stringify(reservation) );
                    let newItem = AgendaItem.toAgendaItem( dayNumber, Number(tenantId), Number(reservationId), reservation );
                    // console.log(newItem);
                    this.a.push(newItem);
                  } else {
                    // console.log( `reservationId: ${reservationId} is empty`);
                  }
                }
              }
            }
          }
        }
      }

      //console.log(JSON.stringify(this.a));

    });

    this.agendaItems$ = of(this.a);
    return this.agendaItems$;
  }

  findAgendaItemsForTenantAndDay( dayOfTheWeek: number ): Observable<AgendaItem[]> {

    this.db.object(AgendaService.agendaPath).valueChanges().subscribe(data => {
      //console.log('data:');
      //console.log(JSON.stringify(data));
      //console.log('this.a:');
      //console.log(JSON.stringify(this.a));

      const currentTenantId = this.authService.getTenantIdForUser();
      this.a.splice(0, this.a.length);  // cleanup old content of array

      for ( let i = 0; i <= Object.keys(data).length; i++ ) {  // iterate over all days, skip day 0
        if ( data[i] ) {
          let day = data[i];
          let dayNumber = i;
          //console.log(`day: : ${JSON.stringify(data[i])}`);
          //console.log(`day of the week: ${dayNumber}`);

          if ( dayNumber === dayOfTheWeek ) {
            const tenantIds = Object.keys( day );
            for ( const tenantId of tenantIds ) {
              if ( Number(tenantId) === currentTenantId) {
                if ( data[i][tenantId] ) {
                  let itemContent = data[i][tenantId];
                  // console.log(`content for tenant ${tenantId}: ${JSON.stringify(itemContent)}`);
                  const reservationIds = Object.keys( itemContent );
                  // console.log( `reservationIds: ${reservationIds}`);

                  for ( const reservationId of reservationIds ) {
                    // console.log( `reservationId: ${reservationIds}` );
                    let reservation = itemContent[reservationId];
                    if ( reservation ) {
                      // console.log( JSON.stringify(reservation) );
                      let newItem = AgendaItem.toAgendaItem( dayNumber, Number(tenantId), Number(reservationId), reservation );
                      // console.log(newItem);
                      this.a.push(newItem);
                      //console.log(`this.a length: ${this.a.length}`);
                    } else {
                      // console.log( `reservationId: ${reservationId} is empty`);
                    }
                  }
                }
              }
            }
          }
        }
      }

      //console.log(JSON.stringify(this.a));

    });

    this.agendaItems$ = of(this.a);
    return this.agendaItems$;

  }


  findAgendaForTenantId( tenantId: number ): Observable<AgendaItem[]> {
    let myItems: AgendaItem[] = [];

    let tenantItems = this.agendaItems$.subscribe( x => {
        const keys = Object.keys(x);
        for ( const key of keys ) {
          let dbTenantId = Number(x[key]['tenantId']);
          if ( dbTenantId === tenantId ) {
              myItems.push( x[key ]);
          }
        }
      }
    );
    myItems.sort( (a, b) => (a.startTime > b.startTime) ? -1 : 1 );

    return of(myItems);
  }

  addAgendaItem( item: AgendaItem ) {
    let newItem = {
      "clubId": null,
      "tenantId": null,
      "court": item.court,
      "day": item.day,
      "startTime": item.startTime,
      "endTime": null,
      "duration": null,
      "name": item.name,
      "type": item.type,
      "request": "DB_CREATE_AGENDA_ITEM"
    };
    if ( item.tenantId ) {
      newItem.tenantId = item.tenantId;
    } else if ( item.clubId ) {
      newItem.clubId = item.clubId;
    } else {
      return; // incomplete request
    }
    if ( item.duration ) {
      newItem.duration = item.duration;
    } else if ( item.endTime ) {
      newItem.endTime = item.endTime;
    }

    this.commandService.sendCommand(newItem);
  }

  updateAgendaItem( item: AgendaItem ) {
    let newItem = {
      "clubId": null,
      "tenantId": null,
      "court": item.court,
      "day": item.day,
      "index": item.index,
      "startTime": item.startTime,
      "endTime": null,
      "duration": null,
      "name": item.name,
      "type": item.type,
      "request": "DB_UPDATE_AGENDA_ITEM"
    };
    if ( item.tenantId ) {
      newItem.tenantId = item.tenantId;
    } else if ( item.clubId ) {
      newItem.clubId = item.clubId;
    } else {
      return; // incomplete request
    }
    if ( item.duration ) {
      newItem.duration = item.duration;
    } else if ( item.endTime ) {
      newItem.endTime = item.endTime;
    }
    //console.log(newItem);
    this.commandService.sendCommand(newItem);
  }

}
